import { gql } from "@apollo/client";

const DECLINE_MOBILITY = gql`
  mutation declineMobility($shortTermID: String!, $email: String!, $name: String!, $position: String!, $reason: String!, $institution: Int!) {
    declineMobility(shortTermID: $shortTermID, email: $email, name: $name, position: $position, reason: $reason, institution: $institution) 
  }
`;

export default DECLINE_MOBILITY;
